'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _h = require('../h3');

var _h2 = _interopRequireDefault(_h);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _paper = require('../paper');

var _paper2 = _interopRequireDefault(_paper);

var _sticky = require('../sticky');

var _sticky2 = _interopRequireDefault(_sticky);

var _paperMenu = require('./paper-menu.css');

var _paperMenu2 = _interopRequireDefault(_paperMenu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generic open/close popup paper styled menu
 */

var PaperMenu = function (_PureComponent) {
  (0, _inherits3.default)(PaperMenu, _PureComponent);

  function PaperMenu(props) {
    (0, _classCallCheck3.default)(this, PaperMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaperMenu.__proto__ || Object.getPrototypeOf(PaperMenu)).call(this));

    _this.onWindowClick = _this.onWindowClick.bind(_this);

    if (props.open) {
      window.addEventListener('click', _this.onWindowClick);
    }
    return _this;
  }

  (0, _createClass3.default)(PaperMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      // We only bind a window click event handler while the menu is open.
      // We also wait for the animation to finish. This means that multiple
      // paper menu’s will not stay open at the same time.
      if (newProps.open && !this.props.open) {
        setTimeout(function () {
          return window.addEventListener('click', _this2.onWindowClick);
        }, 300);
      }
      if (!newProps.open && this.props.open) {
        window.removeEventListener('click', this.onWindowClick);
      }
    }
  }, {
    key: 'onWindowClick',
    value: function onWindowClick(event) {
      if (this.props.open && this.props.closeOnOutsideClick && this.props.onRequestClose) {
        this.props.onRequestClose(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          children = _props.children,
          origin = _props.origin,
          paper = _props.paper,
          root = _props.root,
          heading = _props.heading,
          anchor = _props.anchor,
          offset = _props.offset,
          zIndex = _props.zIndex,
          sticky = _props.sticky,
          optionIcons = _props.optionIcons;


      return React.createElement(
        _sticky2.default,
        (0, _extends3.default)({ anchor: anchor, offset: offset, zIndex: zIndex }, sticky),
        React.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 't-scale',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300,
            transitionAppearTimeout: 300
          },
          open ? React.createElement(
            'div',
            (0, _extends3.default)({}, root, {
              className: _paperMenu2.default.root,
              style: { transformOrigin: origin },
              onClick: function onClick(event) {
                return event.stopPropagation();
              }
            }),
            React.createElement(
              _paper2.default,
              paper,
              heading && React.createElement(
                'div',
                { className: _paperMenu2.default.header },
                React.createElement(
                  _h2.default,
                  null,
                  heading
                ),
                React.createElement(
                  'div',
                  { className: _paperMenu2.default.options },
                  optionIcons,
                  React.createElement(
                    'div',
                    {
                      className: _paperMenu2.default.close,
                      onClick: this.props.onRequestClose
                    },
                    React.createElement(
                      _icon2.default,
                      { size: 18 },
                      'clear'
                    )
                  )
                )
              ),
              children
            )
          ) : null
        )
      );
    }
  }]);
  return PaperMenu;
}(_component2.default);

PaperMenu.defaultProps = {
  children: '',
  origin: 'top left',
  open: false,
  anchor: 'bottom',
  zIndex: 100,
  paper: {
    rounded: true,
    elevation: 2,
    hoverElevation: 2
  },
  closeOnOutsideClick: true
};
exports.default = PaperMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/paper-menu/paper-menu.js
// module id = 343
// module chunks = 114276838955818